module.exports = __webpack_public_path__ + "static/media/06_APOTHEO_LABO_BAYER.40ebbae3.png";